import React, { useState } from 'react'
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; 

const projects = [
	{
		images: [ "https://images.unsplash.com/photo-1442530792250-81629236fe54?ixlib=rb-0.3.5&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=980&h=980&fit=crop&s=9631adb2d2f752e3a0734f393fef634b"],
		title: "Project 1",
		description: "I done my first project"
	},
	{
		images: [ "https://images.unsplash.com/photo-1442530792250-81629236fe54?ixlib=rb-0.3.5&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=980&h=980&fit=crop&s=9631adb2d2f752e3a0734f393fef634b"],
		title: "Project 2",
		description: "I done my second project"
	},
	{
		images: [ "https://images.unsplash.com/photo-1468851508491-4f854ec88aa0?ixlib=rb-0.3.5&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=900&h=900&fit=crop&s=b1222b6a1d3694cac76d2a23c3a02254"],
		title: "Project 3",
		description: "I done my third project"
	},
	{
		images: [ "https://images.unsplash.com/photo-1442530792250-81629236fe54?ixlib=rb-0.3.5&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=980&h=980&fit=crop&s=9631adb2d2f752e3a0734f393fef634b"],
		title: "Project 4",
		description: "I done my fourth project"
	},
]

function ImageGallery(props) {

	const [show, setShow] = useState(false);
	const [project, setProject] = useState(null);
	const [photoIndex, setPhotoIndex] = useState(0);

	const showLightBox = (project) => {
		setProject(project)
		setShow(true)
	}

	const lightbox = () => {
		console.log(project)
		return (
			<Lightbox
				mainSrc={project[photoIndex]}
				nextSrc={project[(photoIndex + 1) % project.length]}
				prevSrc={project[(photoIndex + project.length - 1) % project.length]}
				onCloseRequest={() => setShow( false )}
				onMovePrevRequest={() =>
				setPhotoIndex( (photoIndex + project.length - 1) % project.length) }
				onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % project.length) }
			/>
		)
	}

	return (
		<>
		{show && lightbox()}
		<div className="content ">
				
				<div className="grid">
					<figure className="effect-sadie" onClick={() => showLightBox(projects[0].images)}>
						<img src={projects[0].images[0]} alt="img04"/>
						<figcaption>
							<h2>{projects[0].title}</h2>
							<p>{projects[0].description}</p>
						</figcaption>			
					</figure>
					<figure className="effect-sadie" onClick={() => showLightBox(projects[0].images)}>
						<img src={projects[0].images[0]} alt="img04"/>
						<figcaption>
							<h2>{projects[0].title}</h2>
							<p>{projects[0].description}</p>
						</figcaption>			
					</figure>
					
				</div>
				<div className="grid">
					<figure className="effect-ruby" onClick={() => showLightBox(projects[1].images)}>
						<img src={projects[1].images[0]} alt="img04"/>
						<figcaption>
							<h2>{projects[1].title}</h2>
							<p>{projects[1].description}</p>
						</figcaption>			
					</figure>
					<figure className="effect-ruby" onClick={() => showLightBox(projects[1].images)}>
						<img src={projects[1].images[0]} alt="img04"/>
						<figcaption>
							<h2>{projects[1].title}</h2>
							<p>{projects[1].description}</p>
						</figcaption>			
					</figure>
					
				</div>
				<div className="grid">
					<figure className="effect-layla" onClick={() => showLightBox(projects[2].images)}>
						<img src={projects[2].images[0]} alt="img06"/>
						<figcaption>
							<h2>{projects[2].title}</h2>
							<p>{projects[2].description}</p>
							
						</figcaption>			
					</figure>
					<figure className="effect-layla" onClick={() => showLightBox(projects[2].images)}>
						<img src={projects[2].images[0]} alt="img06"/>
						<figcaption>
							<h2>{projects[2].title}</h2>
							<p>{projects[2].description}</p>
							
						</figcaption>			
					</figure>
				</div>
				
				<div className="grid">
					<figure className="effect-oscar" onClick={() => showLightBox(projects[3].images)}>
						<img src={projects[3].images[0]} alt="img09"/>
						<figcaption>
							<h2>{projects[3].title}</h2>
							<p>{projects[3].description}</p>
						</figcaption>			
					</figure>
					<figure className="effect-oscar" onClick={() => showLightBox(projects[3].images)}>
						<img src={projects[3].images[0]} alt="img09"/>
						<figcaption>
							<h2>{projects[3].title}</h2>
							<p>{projects[3].description}</p>
						</figcaption>			
					</figure>
				</div>
				
				
			</div>
			</>
	);
	
}

export default ImageGallery;